{
  "_": "LA matrice des droits du panel, lue par Python (panel/cuentas.py, qui applique) et par l'interface React (qui masque). Un rôle absent d'une action = refusé. `operator` = l'équipe Responia (Munay), jamais un client.",
  "roles": ["owner", "admin", "editor", "viewer", "operator"],
  "roles_cliente": ["owner", "admin", "editor", "viewer"],
  "acciones": {
    "leer": ["owner", "admin", "editor", "viewer", "operator"],
    "exportar": ["owner", "admin", "editor", "viewer", "operator"],
    "sesiones.propias": ["owner", "admin", "editor", "viewer", "operator"],
    "conversacion.responder": ["owner", "admin", "editor", "operator"],
    "cita.gestionar": ["owner", "admin", "editor", "operator"],
    "contacto.reanudar": ["owner", "admin", "editor", "operator"],
    "grabacion.escuchar": ["owner", "admin", "editor", "operator"],
    "negocio.editar": ["owner", "admin", "editor", "operator"],
    "automatizacion.cambiar": ["owner", "admin", "operator"],
    "asistente.publicar": ["owner", "admin", "operator"],
    "campana.preparar": ["owner", "admin", "editor", "operator"],
    "campana.lanzar": ["owner", "admin", "operator"],
    "datos.gestionar": ["owner", "admin", "operator"],
    "sedes.gestionar": ["owner", "admin", "operator"],
    "equipo.ver": ["owner", "admin", "operator"],
    "equipo.gestionar": ["owner", "admin", "operator"],
    "auditoria.ver": ["owner", "admin", "operator"],
    "facturacion": ["owner", "operator"],
    "cuenta.borrar": ["owner"],
    "coste.ver": ["operator"]
  },
  "endpoints": {
    "GET /me": "sesiones.propias",
    "GET /hoy": "leer",
    "GET /conversaciones": "leer",
    "GET /conversacion": "leer",
    "GET /citas": "leer",
    "GET /contactos": "leer",
    "GET /contacto": "leer",
    "GET /negocio": "leer",
    "GET /canales": "leer",
    "GET /automatizaciones": "leer",
    "GET /analisis": "leer",
    "GET /campanas": "leer",
    "GET /campana": "leer",
    "POST /campanas/analizar": "campana.preparar",
    "POST /campanas/crear": "campana.preparar",
    "POST /campanas/estado": "campana.lanzar",
    "GET /exportar": "exportar",
    "GET /grabacion": "grabacion.escuchar",
    "GET /datos": "equipo.ver",
    "GET /sedes": "leer",
    "POST /sedes/guardar": "sedes.gestionar",
    "POST /sedes/borrar": "sedes.gestionar",
    "POST /datos": "datos.gestionar",
    "GET /plan": "facturacion",
    "GET /sesiones": "sesiones.propias",
    "GET /equipo": "equipo.ver",
    "GET /auditoria": "auditoria.ver",
    "GET /stream": "leer",
    "POST /salir": "sesiones.propias",
    "POST /sesiones/cerrar-otras": "sesiones.propias",
    "POST /sesion/cliente": "sesiones.propias",
    "POST /negocio": "negocio.editar",
    "POST /automatizaciones": "automatizacion.cambiar",
    "POST /agenda/probar": "negocio.editar",
    "POST /citas/cancelar": "cita.gestionar",
    "POST /citas/mover": "cita.gestionar",
    "POST /citas/asistencia": "cita.gestionar",
    "POST /contacto/reanudar": "contacto.reanudar",
    "POST /conversacion/modo": "conversacion.responder",
    "POST /conversacion/enviar": "conversacion.responder",
    "POST /equipo/invitar": "equipo.gestionar",
    "POST /equipo/rol": "equipo.gestionar",
    "POST /equipo/quitar": "equipo.gestionar",
    "POST /cuenta/borrar": "cuenta.borrar"
  },
  "publicos": ["POST /acceso/enlace", "POST /acceso/canjear"]
}
